import { Progress as ProgressPrimitive } from '@base-ui/react/progress';
import { ProgressIndicator, ProgressTrack } from 'components/ui/progress';
import { cn } from 'utils/cn';

const COLOR = { primary: 'bg-primary', secondary: 'bg-secondary', success: 'bg-success' } as const;

type Props = {
    /** 0-100. */
    value: number;
    variant: 'determinate';
    color?: keyof typeof COLOR;
    className?: string;
};

/**
 * A determinate progress bar. The fill is a full-width bar slid left by the remaining share, so a
 * changing value moves it with `transform` and never registers as layout shift.
 */
export default function LinearProgressStyled({ value, color = 'primary', className }: Props) {
    return (
        <ProgressPrimitive.Root value={value} className="w-full">
            <ProgressTrack className={cn('h-1.5', className)}>
                <ProgressIndicator
                    className={cn('w-full rounded-full transition-none', COLOR[color])}
                    style={{ width: '100%', transform: `translateX(-${100 - Math.min(Math.max(value, 0), 100)}%)` }}
                />
            </ProgressTrack>
        </ProgressPrimitive.Root>
    );
}
